import { render, staticRenderFns } from "./moblieScreenBack.vue?vue&type=template&id=414638b9&scoped=true"
import script from "./moblieScreenBack.vue?vue&type=script&lang=js"
export * from "./moblieScreenBack.vue?vue&type=script&lang=js"
import style0 from "./moblieScreenBack.vue?vue&type=style&index=0&id=414638b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414638b9",
  null
  
)

export default component.exports